import React, { useState } from 'react';
import { ChevronDown, ChevronUp, CheckCircleFill } from 'react-bootstrap-icons';
import './TeamAvailabilityTracker.css';
import { teams } from '../../utils/teamList';
import teamIcons from '../../utils/teamIcons';
import { getByeWeeks } from '../../utils/scheduleHelpers';

// Every team you've already picked this season (in any week) is unavailable for
// the rest of it -- the pick buttons already enforce this server-side, but
// seeing the full 32-team picture up front is what actually lets someone plan
// which teams to save for tougher weeks later on.
function TeamAvailabilityTracker({ userPicks, games, currentWeek, onSelectTeam, onExpand }) {
    const [expanded, setExpanded] = useState(false);

    function toggleExpanded() {
        const next = !expanded;
        setExpanded(next);
        // Bye-week tags need `games` (the whole-season schedule), which the
        // page fetches lazily on first actual need rather than eagerly on
        // load -- expanding this for the first time counts as that need.
        if (next && onExpand) onExpand();
    }

    const usedTeams = new Set(
        userPicks
            .map((pick) => Object.keys(pick)[0])
            .filter((team) => team && !team.includes('Team'))
    );
    const byeWeeks = getByeWeeks(games);
    const realTeams = teams.filter((t) => t !== 'Team');
    const availableCount = realTeams.length - usedTeams.size;

    return (
        <div className='team-availability-section'>
            <button
                type='button'
                className='team-availability-toggle'
                onClick={toggleExpanded}
            >
                <span className='section-heading'>Available Teams</span>
                <span className='team-availability-count'>{availableCount} of {realTeams.length} left</span>
                {expanded ? <ChevronUp /> : <ChevronDown />}
            </button>
            {expanded && (
                <div className='team-availability-grid'>
                    {realTeams.map((team) => {
                        const used = usedTeams.has(team);
                        const TeamIcon = teamIcons[team];
                        const isByeThisWeek = currentWeek != null && byeWeeks[team] === currentWeek;
                        return (
                            <button
                                type='button'
                                key={team}
                                className={'team-availability-chip' + (used ? ' used' : '')}
                                onClick={() => onSelectTeam && onSelectTeam(team)}
                            >
                                {used && <CheckCircleFill className='team-availability-used-icon' />}
                                {TeamIcon && <TeamIcon />}
                                <span className='team-availability-name'>{team}</span>
                                {!used && isByeThisWeek && <span className='team-availability-bye-tag'>BYE</span>}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default TeamAvailabilityTracker;
